"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.jsonSchemaV003 = void 0;
const schema_json_1 = require("../0.0.2/schema_json");
exports.jsonSchemaV003 = Object.assign(Object.assign({}, schema_json_1.jsonSchemaV002), { $id: "http://schema.canotic.com/v0.0.3/", definitions: Object.assign(Object.assign({}, schema_json_1.jsonSchemaV002.definitions), { TOKEN_TAGS: {
            $id: "token-tags",
            description: "Result of token annotation",
            type: "object",
            properties: {
                index: {
                    type: "integer"
                },
                tags: {
                    type: "array",
                    items: {
                        $ref: "text"
                    }
                }
            },
            required: ["index", "tags"]
        }, TOKEN_ANNOTATION: {
            $id: "token-annotation",
            description: "Annotation on a tokenized natural language text",
            type: "object",
            properties: {
                tokens: {
                    type: "array",
                    items: {
                        $ref: "text"
                    }
                },
                choices: {
                    type: "array",
                    description: "List of choices that will be shown to the task annotator",
                    items: {
                        $ref: "choice"
                    },
                    minItems: 1
                },
                value: {
                    type: "array",
                    items: {
                        $ref: "token-tags"
                    }
                }
            },
            required: ["tokens", "choices"]
        } }) });
